import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";
import CompanyDetails from "../../Models/companies/Company";

export default (id: string | number, filterByUser: boolean | null = false) =>
  axiosApi.get<CompanyDetails>(
    `${BackendServices.COMPANY_SERVICE.COMPANY}/${id}?filterByUser=${filterByUser}`
  );
